import { CustomBuilderComponents } from '@/helpers/enums';
import {
  childComponents,
  childComponentsAsString,
} from './SectionWithChildren';

export const sectionWithChildrenBuilderConfigs = {
  name: CustomBuilderComponents.SECTION_WITH_CHILDREN,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/extension-add.svg',
  inputs: [
    {
      name: 'Admin Tips',
      type: 'adminTips',
      defaultValue: `Accepts Child Components: ${childComponentsAsString}`,
    },
    {
      name: 'backgroundImage',
      type: 'file',
      friendlyName: 'Background Image',
      allowedFileTypes: ['jpeg', 'png'],
      required: true,
    },
  ],
  childRequirements: {
    message: `You can only nest "${childComponentsAsString}" inside SectionWithChildren`,
    query: {
      'component.name': { $in: childComponents },
    },
  },
};
